import { getGlobalContent, getBrand } from '@utils/contentful'
import router from '@router'

const setVar = (name, value) => {
  if (value) {
    document.documentElement.style.setProperty(name, value)
  }
}

export const state = {
  brand: null,
  content: null,
  contentIsRetrieved: null,
  loading: null,
  restaurantDetails: null,
}

export const getters = {
  getAppIsEnabled: (state) => {
    return state?.content?.enabled
  },
  getBrand: (state) => {
    return state?.brand
  },
  getContent: (state) => {
    return state?.content
  },
  getContentIsRetrieved: (state) => {
    return state?.contentIsRetrieved
  },
  getLoading: (state) => {
    return state?.loading
  },
  getRestaurantIsEnabled: (state) => {
    return state?.restaurantDetails?.enabled
  },
}

export const mutations = {
  setBrand(state, { brand }) {
    state.brand = brand
  },
  setContent(state, { content }) {
    state.content = content
  },
  setContentIsRetrieved(state, { contentIsRetrieved }) {
    state.contentIsRetrieved = contentIsRetrieved
  },
  setLoading(state, { loading }) {
    state.loading = loading
  },
  setRestaurantDetails(state, { restaurantDetails }) {
    state.restaurantDetails = restaurantDetails
  },
}

export const actions = {
  async init({ commit, dispatch }) {
    try {
      commit('setLoading', { loading: true })

      const content = await getGlobalContent()
      const brand = await getBrand()

      // Handle no content
      if (!content) {
        router.push('/404').catch(() => {})
        throw new Error(
          'Something went wrong when trying to fetch the content. Please try again.'
        )
      }

      // Set content
      commit('setBrand', { brand })
      dispatch('setContent', { content })

      // Set colours
      setVar('--color-primary', brand?.primaryColour)
      setVar('--color-secondary', brand?.secondaryColour)

      // Handle global killswitch
      if (!content.enabled && router.history.current.name !== 'unavailable') {
        router.push('/unavailable').catch(() => {})
      }
    } catch (error) {
      // eslint-disable-next-line
      console.log(error)
      dispatch('handleError', { error })
    }
  },

  setContent({ commit }, { content }) {
    commit('setContent', { content })
    commit('setContentIsRetrieved', { contentIsRetrieved: true })
    commit('setLoading', { loading: false })
  },

  handleError({ commit, dispatch }, { error }) {
    commit('setLoading', { loading: false })
    dispatch('ui/showError', error, { root: true })
  },
}
